import { Card, Stack, useWindowProperties } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AppShell from '~/components/shared/AppShell/AppShell';
import { PasscodeCardActions } from '~/components/shared/Passcode/PasscodeCardActions';
import { PasscodeCardContent } from '~/components/shared/Passcode/PasscodeCardContent';
import constVars from '~/constants/constVars';
import { history } from '~/constants';
import { svcOnboardingAuthStore } from '~/contexts/AuthContext/SvcOnboardingAuthStore';
import { selectPasscodeView } from '~/store/slices/passcode.slice';
import { StepsContainer } from '~/styles/BaseStyledComponents';

/**
 * Reset page opened from an emailed reset link, after WebID re-authentication.
 * The set call is an upsert, so no status check is needed first; passing
 * hasExistingPasscode={false} makes the flow always start on the create view.
 */
const CreatePasscodeStandalone = () => {
  const { isMobile } = useWindowProperties();
  const view = useSelector(selectPasscodeView);

  // The reset is meant to be one-time use. On success, this clears the WebID
  // token so it cannot stay valid in this tab and be replayed to set the
  // passcode again.
  //
  // It also redirects to a static landing page, since a reload of this reset
  // page would otherwise re-run WebID identification against a link that's
  // already spent.
  useEffect(() => {
    if (view?.kind === 'success') {
      svcOnboardingAuthStore.clearToken();
      history.replace(`/${constVars.ROUTE_CREATE_PASSCODE_DONE}`);
    }
  }, [view]);

  return (
    <AppShell>
      <StepsContainer>
        <Card
          bg="miscellaneous.white"
          mt={isMobile ? 0 : 60}
          p={0}
          w="100%"
          display="flex"
          style={{ overflow: 'auto', flexGrow: 1 }}
        >
          <Stack spacing="xl" p="1.5em" style={{ width: '100%' }}>
            <PasscodeCardContent
              hasExistingPasscode={false}
              successDescription="CreatePasscode.SuccessDescriptionStandalone"
            />
            <PasscodeCardActions hasExistingPasscode={false} />
          </Stack>
        </Card>
      </StepsContainer>
    </AppShell>
  );
};

export default CreatePasscodeStandalone;
